import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-styles-viewer',
  templateUrl: './styles-viewer.html'
})
export class StylesViewerComponent implements OnInit {
  // hoveringItem = 'Dashboard';
  // selectedItem = 'Trips';
  hoveringItem = 'Setup';
  selectedItem = '';
  dataSource = [{
      name: 'francois'
    }, {
      name: 'daniel'
    }, {
      name: 'franco'
  }];

  constructor() { }

  ngOnInit() {
  }

}
